import script from "./AgencyKitEmailRecipients.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyKitEmailRecipients.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__